import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-atualizacao-contato-pessoa-modal',
  templateUrl: './atualizacao-contato-pessoa-modal.component.html',
  styleUrl: './atualizacao-contato-pessoa-modal.component.scss'
})
export class AtualizacaoContatoPessoaModalComponent implements OnInit {

  vinculos: any[] = [];
  novoContato: any;
  allSelected = false;
  atualizacaoContatoPessoaForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) { }

  ngOnInit(): void {
    this.buildForm();
    console.log('vinculos-list', this.vinculos);
    console.log('contato-edit', this.novoContato);
  }

  buildForm(): void {
    this.atualizacaoContatoPessoaForm = this.fb.group({
      vinculoIds: []
    });
  }

  buildLabel(item: any): string {
    const areaAtuacao = item?.areaAtuacaoPessoaEntidadeLotada ? item.areaAtuacaoPessoaEntidadeLotada : '';
    const cargo = item?.cargoPessoaEntidadeRepresentada ? item.cargoPessoaEntidadeRepresentada : '';
    const nomePessoa = item?.nomePessoa ? item.nomePessoa : '';
    const idV = item?.id ? `[${item.id}]` : '';

    // Monta a string concatenando os valores existentes
    return `${areaAtuacao} ${cargo} ${nomePessoa} ${idV}`.trim().replace(/\s+/g, ' ');
  }

  onSelectChange(selectedValues: any[]): void {
    const allItems = this.vinculos.map(item => item.id);

    if (!selectedValues.length) {
      // Caso o botão "x" seja clicado para limpar tudo, redefina `allSelected`
      this.allSelected = false;
      return;
    }

    if (selectedValues.includes('selectAll')) {
      // Se a opção "Selecionar Todos" foi clicada, remove ela e realiza a seleção
      selectedValues = selectedValues.filter(value => value !== 'selectAll');

      if (!this.allSelected) {
        this.vinculoIds?.setValue(allItems);
        this.allSelected = true;
      } else {
        // Desmarca todos
        this.vinculoIds?.setValue([]);
        this.allSelected = false
      }
    } else {
      // Verifica se todos os itens foram selecionados manualmente
      const allItemsSelected = allItems.every(itemId => selectedValues.includes(itemId));
      this.allSelected = allItemsSelected;
    }
  }

  editarContatos(): void {
    let objEnvio = { entidadeContato: this.novoContato, ...this.atualizacaoContatoPessoaForm.getRawValue() };
    console.log(objEnvio);
    this.modalRef.close(objEnvio);
    /*const flagPrincipal = this.contatoForm.get('flagPrincipal')?.value;
    if (flagPrincipal && this.dataSet.some(contact => contact.flagPrincipal
      && contact.id !== this.contatoForm.get('id')?.value)) {
      alert('Já existe um contato principal.');
    } else {
      this.isVisible = false;
      let objEnvio = { ...this.contatoForm.getRawValue() };
    }*/
  }

  handleCancel(): void {
    this.modalRef.close();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    } if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    } else if (a?.id !== undefined && b !== undefined) {
      return a.id === b;
    } else if (a !== undefined && b?.id !== undefined) {
      return a === b?.id;
    } else if (a?.uf !== undefined && b?.sigla !== undefined) {
      // console.log('a.uf', a.uf);
      return a?.uf === b?.sigla
    } else if (a?.cidade !== undefined && b?.nome !== undefined) {
      // console.log('a.cidade', a.cidade);
      // console.log('b.nome', b.nome);
      return a?.cidade === b?.nome && a?.uf === b?.uf.sigla
    } else {
      return a === b;
    }
  }

  get vinculoIds() {
    return this.atualizacaoContatoPessoaForm.get('vinculoIds');
  }
}
